class OacListFilterValueConverter {
  toView(list, fn) {
    return list.filter(fn);
  }
}

export { OacListFilterValueConverter };
